export const FRAUD_PREVENTION_POLICY = {
  id: 'fraud-prevention-policy',
  title: 'Fraud Prevention Policy',
  version: 'v1.0-2026-05-17',
  effectiveDate: '17/05/2026',
  audience: 'all',
  content: `FRAUD PREVENTION POLICY — RESERVO

Status: DRAFT — pending solicitor review

1. PURPOSE

This policy describes Reservo's measures to prevent, detect, and respond to fraudulent activity on the Reservo platform.

2. SCOPE

This policy applies to all users (Riders, Drivers, corporate account holders) and to Reservo personnel.

3. DEFINITIONS

3.1 "Fraud" — any deliberate deception intended to obtain a benefit (financial or otherwise) or to cause loss to another party.

3.2 Examples of fraud on the Reservo platform include:
  (a) creating an account under a false name or stolen identity;
  (b) using a stolen, counterfeit, or unauthorised payment method;
  (c) submitting false damage or cleaning claims;
  (d) staging fake incidents to extract payouts;
  (e) collusion between Driver and Rider to inflate fares;
  (f) circumventing Reservo to take bookings off-platform;
  (g) manipulating ratings, referrals, or the rewards program;
  (h) inflating GPS trace, surge pricing, or fatigue records;
  (i) reusing or sharing accounts in breach of these Terms;
  (j) impersonating a Reservo administrator or law-enforcement officer.

4. PREVENTION CONTROLS

4.1 Identity verification:
  (a) phone number verification by SMS OTP at registration;
  (b) email verification at registration;
  (c) government-issued photo ID required for Driver onboarding;
  (d) optional photo ID for Riders flagged as elevated risk.

4.2 Payment-method controls:
  (a) Stripe operates 3-D Secure where supported;
  (b) Reservo does not store full card numbers;
  (c) repeated card failures trigger account flag and admin review;
  (d) high-value or unusual transactions trigger review.

4.3 Behavioural monitoring:
  (a) automated detection of unusual patterns (multiple accounts per device, rapid successive cancellations, geographically impossible trips);
  (b) trip GPS validation against booking pickup and destination;
  (c) ratings-pattern analysis to detect collusion or retaliation;
  (d) rewards-points integrity checks.

4.4 Off-platform contracting prevention:
  (a) Driver and Rider phone numbers are not shared;
  (b) in-app messaging is filtered for external contact attempts;
  (c) repeated detection results in suspension.

4.5 Damage and cleaning claim integrity:
  (a) minimum 3 photographs required;
  (b) admin review of every claim;
  (c) cross-check against trip duration, route, and prior history.

5. DETECTION

5.1 Reservo monitors:
  (a) account creation, login, and activity patterns;
  (b) payment transactions and chargebacks;
  (c) cancellation rates and patterns;
  (d) damage and lost-item claim frequency per account;
  (e) device fingerprints and IP addresses;
  (f) external reports from Stripe or other partners.

5.2 Detected indicators trigger account flagging and admin review.

6. RESPONSE

6.1 On a confirmed or strongly suspected fraud:
  (a) the affected account is suspended pending investigation;
  (b) the matter is logged in the fraud register;
  (c) the Operator reviews and determines proportionate action;
  (d) where the matter involves criminal conduct, it is reported to NSW Police;
  (e) where the matter affects payment systems, Stripe is notified;
  (f) where the matter affects a Notifiable Occurrence, the Commissioner is notified.

6.2 Outcomes may include:
  (a) account termination;
  (b) recovery of fraudulent payouts via clawback or civil action;
  (c) banning the user from re-registering;
  (d) referral to authorities.

7. WHISTLEBLOWER PROTECTION

7.1 Reservo encourages reports of suspected fraud by users or personnel.

7.2 Reports can be made to admin@reservo.au.

7.3 Reports made in good faith are confidential and the reporter is protected from retaliation.

8. RECORD KEEPING

8.1 All fraud investigations are recorded in the fraud register and retained for 7 years.

8.2 Records include: report date, reporter, allegation, evidence, investigation findings, outcome, regulatory notifications.

9. TRAINING

9.1 Driver onboarding includes a fraud-awareness module covering: damage-claim integrity, off-platform booking prohibition, rewards-system integrity, account-sharing prohibition.

9.2 Reservo personnel handling investigations receive specific fraud-handling training.

10. REVIEW

10.1 This policy is reviewed annually and after any significant fraud incident.

---
VERSION HISTORY
v1.0 — 17/05/2026 — Initial draft for solicitor review.

---
THIS DOCUMENT IS A DRAFT FOR PRE-LAUNCH REVIEW.`,
};